const currentDomain = window.location.hostname;
let apiDomain = "";
let awsS3Domain = "";

if (currentDomain === "localhost") {
    apiDomain = "localhost:8003";
} else {
    const prefix = window.ENV.ENVIRONMENT === "stage" ? "api-" : "api.";
    apiDomain = currentDomain.startsWith("www.")
        ? currentDomain.replace("www.", prefix)
        : prefix + currentDomain;
    awsS3Domain = currentDomain.startsWith("www.")
        ? currentDomain.replace("www.", "img.")
        : "img." + currentDomain;
}

let apiUrl = "";
let awsUrl = "";
let adminUrl = "";
if (currentDomain === "localhost") {
    // during development, use the local API and AWS URLs from config.js
    apiUrl = window.ENV.API_URL
    awsUrl = window.ENV.AWS_URL
    adminUrl = window.ENV.ADMIN_URL
} else if (window.ENV.USE_PATH === "TRUE") {
    // if USE_PATH is set to TRUE, use the path-based URLs
    apiUrl = `https://${apiDomain}/api/`
    awsUrl = `https://${awsS3Domain}/public/`;
    // apiDomain cut last . and after and replace with .vip
    adminUrl = window.ENV.ADMIN_URL || `https://${currentDomain.replace(/(\.[^.]+)$/, ".vip")}`;
} else {
    // if USE_PATH is not set to TRUE, use the default URLs
    apiUrl =
        window.ENV.API_URL || `https://${apiDomain}/api/`;
    awsUrl =
        window.ENV.AWS_URL || `https://${awsS3Domain}/public/`;
    adminUrl =
        window.ENV.ADMIN_URL || `https://${currentDomain.replace(/(\.[^.]+)$/, ".vip")}`;
}

const config = {
    timezone: "Asia/Singapore",
    apiURL: apiUrl,
    awsUrl: awsUrl,
    region: window.ENV.REGION || "netplay",
    client: window.ENV.CLIENT || "netplay",
    adminURL: adminUrl || "",
};

export default config;